"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var DELAY_TIMEOUT = 5000; // https://git.hubteam.com/HubSpot/CRM/blob/671305c8cf23ace164066c490e4eb1652a1634a3/crm_ui/static/js/utils/delayUntilIdle.js

var _default = function _default(callback) {
  var delay = window.requestIdleCallback || window.setTimeout;
  var delayOptions = delay === window.requestIdleCallback ? {
    timeout: DELAY_TIMEOUT
  } : 0;
  delay(callback, delayOptions);
};

exports.default = _default;
module.exports = exports.default;